import { REQUEST_PATHS } from "~/const/request";
import { request } from "~/util/request";

type ConversionApiResponse = {
  code: number;
  html: { head: string; body_start: string; body_mailmagazine: string; body_end: string };
};

/**
 * ### 決済完了後にConversionAPIを呼び出してレスポンス結果のタグをViewに設置するまでの共通関数
 *
 * @param userId useAuth Custom Hooks の返り値の userId
 * @see API仕様書 https://confl.arms.dmm.com/pages/viewpage.action?pageId=1280311798
 */
export const conversionApi = async (userId: string, seasonId: string) => {
  // MEMO : axios で application/x-www-form-urlencoded の形式でリクエストを送るためには URLSearchParams でクエリパラメータに変換する必要がある
  // @see https://axios-http.com/docs/urlencoded
  const params = new URLSearchParams();
  params.append("mode", "get");
  params.append("open_id", userId);

  const { data } = await request.post<ConversionApiResponse>(REQUEST_PATHS.CONVERSION_API, params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  const cvTagContainer = document.createElement("output");

  let cvTag = data.html.body_end;

  // MEMO : <script>はinnerHTMLにセットしても実行されないため改めてDOMのノードとして設置
  const scripts = cvTag.match(new RegExp("<script.*?>.*?</script>", "migs"));

  if (scripts !== null) {
    const scriptCodes = [];

    for (let i = 0; i < scripts.length; i++) {
      let regExpString = scripts[i].match(new RegExp("<script.*?>(.+?)</script>", "mis"))?.[1];

      if (regExpString !== undefined) {
        if (regExpString.indexOf("i3 conversion tag") >= 0) {
          regExpString = regExpString.replace(/content_id: 'dummy',/, "content_id: '" + seasonId + "',");
        }

        scriptCodes.push(regExpString);
        cvTag = cvTag.replace(new RegExp("<script.*?>.*?</script>", "mis"), "");
      }
    }

    for (let i = 0; i < scriptCodes.length; i++) {
      const addScript = document.createElement("script");

      if (scriptCodes[i] !== "") {
        addScript.innerHTML = scriptCodes[i];
      }

      document.body.appendChild(addScript);
    }
  }

  // MEMO : <script>以外(MarketingCvTag及びメルマガタグ)のタグを設置
  cvTagContainer.innerHTML = cvTag;
  document.body.appendChild(cvTagContainer);
};
